import { render } from "./AdminUserDetail.vue?vue&type=template&id=e10fa17c&scoped=true"
import script from "./AdminUserDetail.vue?vue&type=script&lang=js"
export * from "./AdminUserDetail.vue?vue&type=script&lang=js"

import "./AdminUserDetail.vue?vue&type=style&index=0&id=e10fa17c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e10fa17c"]])

export default __exports__